// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"guest-list-page__wrapper__yxu9P","container":"guest-list-page__container__Du-_m","label":"guest-list-page__label__1xpUs","adult-and-child-count":"guest-list-page__adult-and-child-count__k1cHL","label-line":"guest-list-page__label-line__k34lq","invitations-list":"guest-list-page__invitations-list__ldPok"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/guest-list-page.scss
// module id = 1409
// module chunks = 1